module.exports = __webpack_public_path__ + "static/media/icon-tick.5f927352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-tick.svg
// module id = 832
// module chunks = 0